import window from '../window/index.js';
import { clamp } from '@immutabl3/utils';

const { min } = Math;
const { NEGATIVE_INFINITY, POSITIVE_INFINITY } = Number;

const SCROLL_SCALE = 100;

export const height = (duration, scalar = SCROLL_SCALE) => {
  return scalar * duration;
};

export const scale = (width, height) => {
  return min(
    window.width() / width,
    window.height() / height,
  );
};

export const scrollPerc = (scrollTop, top, height, isLast) => {
  const scroll = scrollTop - top;
  // if last, use the window height as an offset so 
  // that the bottom of the window is the end of the
  // progress
  const perc = scroll / height;
  // even though window is normalizing scrollTop, mobile
  // safari gives a false value for the max page scroll.
  // we're using the "isLast" flag to determine if we
  // should clamp the percentage to keep it from 
  // being greater than 1 and flickering the content when
  // it's at the bottom of the screen
  const max = isLast ? 1 : POSITIVE_INFINITY;
  return clamp(perc, NEGATIVE_INFINITY, max);
};